





































































































































import { Component } from 'vue-property-decorator';
import { FacetValueViewObject } from '@/types/apiServerContract';
import FacetPicker from './FacetPicker.vue';
import { IFacetPicker } from './IFacetPicker';

import FacetPickerRecommendedBrands from './modules/FacetPickerRecommendedBrands.vue';
import InputSearch from '@/project/form/InputSearch.vue';
import dictionaryService from '@/core/translation/dictionary.service';

@Component({
    components: { InputSearch, FacetPickerRecommendedBrands }
})
export default class FacetPickerCheckbox extends FacetPicker implements IFacetPicker {
    private style() {
        const rect = this.$refs.container.getBoundingClientRect();
        return `min-width: ${rect.width}px`;
    }

    private positionStyle: Partial<CSSStyleDeclaration> | null = null;

    private setPositionStyle() {
        const rect = this.$refs.container.getBoundingClientRect();
        const parentRect = document.getElementById('facets-container')!.getBoundingClientRect();
        const top = Math.abs(parentRect.top - rect.top);

        const direction = this.last ? 'right' : 'left';
        const horizontalPosition = Math.abs(parentRect[direction] - rect[direction]);

        this.positionStyle = {
            top: top + 'px',
            [direction]: horizontalPosition + 'px'
        };
    }

    private showRecommendedBrands: boolean = false;
    private setShowRecommendedBrands(state: boolean) {
        this.showRecommendedBrands = state;
    }

    private get hasValues(): boolean {
        return this.facet.values.length > 0;
    }

    getUnitTranslation(unit: string): string {
        return dictionaryService.translate(unit);
    }

    private get getUnitClarificationLabel(): string | null {
        return (this.facet.unitClarification && dictionaryService.translate(this.facet.unitClarification)) || null;
    }

    private togglePopup(): void {
        if (!this.active) {
            this.setPositionStyle();
            this.open();
        } else {
            this.close();
        }
    }

    public toggle(selected: FacetValueViewObject) {
        if (this.isSingleSelect) {
            for (const value of this.values) {
                value.selected = value.key === selected.key && !value.selected;
            }
        } else {
            selected.selected = !selected.selected;
        }

        this.updateFacetValue(selected);
    }

    private get tooltipMessage() {
        return this.isPriceFilter && !this.facet.enabled ? dictionaryService.get('Search.Facets.PriceSortDisabled') : '';
    }

    public $refs!: {
        container: HTMLElement
    }

    private isValueDisabled(value: FacetValueViewObject) {
        return !value.isFacet && value.productCount === 0;
    }
}
